import React from 'react'
import { IconButton } from '@st-operations/uikit/src/v2'

import './styles.scss'

const ExpandButton = ({ style, onClick, isExpanded }) => {
  return (
    <div className="expand-button" style={style}>
      <IconButton
        classes={{ button: 'expand-button__button' }}
        iconProps={{
          type: 'outline',
          icon: isExpanded ? 'delete' : 'expand',
          color: 'currentColor',
        }}
        onClick={onClick}
      />
    </div>
  )
}

export default ExpandButton
